import React from "react";

const ISS = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Rota /iss funcionando ✅</h1>
    </div>
  );
};

export default ISS;